<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.apps')"
      show_usermenu
    ></my-header>
    <el-dialog :visible.sync="deleteDialog" width="40%">
      <span slot="title" class="delete-dialog-title">
        <div>{{ $t("sections.selectAction") }}</div>
        <div class="delete-dialog-element-name">{{ sectionName }}</div>
      </span>
      <div v-if="getBasesInSection.length > 0">
        {{
          $t("sections.numberOfLinkedBases") + ": " + getBasesInSection.length
        }}
        <br />{{ $t("sections.selectBasesToUntie") + ":" }}
        <el-select v-model="basesToUnlink" multiple :key="selectKey" filterable>
          <el-option
            v-for="(base, index) in getBasesInSection"
            :key="index"
            :label="baseLabel(base)"
            :value="base.idBase"
          ></el-option>
        </el-select>
        <el-button @click="unlinkAllBases" size="mini" type="text">{{
          $t("sections.selectAllBases")
        }}</el-button>
        <el-button @click="basesToUnlink = []" size="mini" type="text">{{
          $t("sections.unselectAllBases")
        }}</el-button>
        <br />
        <el-radio v-model="deleteRadio" label="unlink">{{
          $t("sections.untieSelectedBasesFromApp")
        }}</el-radio>
      </div>
      <div v-else>{{ $t("sections.noUntiedBasesToThisApp") }}</div>
      <el-radio v-model="deleteRadio" label="hard">{{
        $t("sections.deleteApp")
      }}</el-radio>

      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="deleteDialog = false"
            >{{ $t("sections.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okClickDelete"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 'making sure' dialog -->
    <el-dialog :visible.sync="deleteConfirmationDialog" width="40%">
      <span slot="title" class="delete-dialog-title">
        <div>{{ $t("sections.selectAction") }}</div>
        <div class="delete-dialog-element-name">{{ sectionName }}</div>
      </span>
      <div style="word-break: normal">
        <div>{{ $t("sections.thisActionDeleteAppWholly") }}.</div>
        <br />
        <div>
          {{
            $t("sections.basesAndPackets", {
              bases: getBasesInSection.length,
              packets: sectionPackets.length,
            })
          }}.
        </div>
        <br />
        {{ $t("sections.continue") }}?
      </div>
      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="deleteConfirmationDialog = false"
            >{{ $t("sections.cancel") }}</el-button
          >
          <el-button
            class="button-cancel"
            type="plain"
            @click="infoDialogOpen = true"
            >{{ $t("referenceGrid.info") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="deleteSectionHard"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="infoDialogOpen"
      v-if="infoDialogOpen"
      :title="$t('referenceGrid.bindsInfo')"
      center
      width="60%"
    >
      <div>
        <b>{{ $t("referenceGrid.basesLinkedToApp") + ":" }}</b>
        <div
          v-for="(base, index) in getBasesInSection"
          :key="index"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ baseLabel(base) }}</span>
        </div>
        <br />
        <div v-if="getBasesInSection.length === 0">
          {{ $t("referenceGrid.noLinkedBasesToCurrentApp") }}
        </div>
        <br />
        <b>{{ $t("referenceGrid.packetsWithSection") + ":" }}</b>
        <div
          v-for="packet in sectionPackets"
          :key="packet.name"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ packet.name }}</span>
        </div>
        <br />
        <div v-if="sectionPackets.length === 0">
          {{ $t("referenceGrid.noPacketsWithSection") }}
        </div>
      </div>
    </el-dialog>
    <reference-grid
      :gridData="getSectionsTableArray"
      :columns="columnDefs"
      gridType="app"
      @deleteClicked="deleteClick"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import { mapGetters } from "vuex";
import i18n from "@/locales";
export default {
  data() {
    return {
      columnDefs: [],
      deleteDialog: false,
      deleteRadio: "",
      deleteConfirmationDialog: false,
      infoDialogOpen: false,
      selectKey: 0,
      basesToUnlink: [],
      sectionName: null,
      currentId: null,
    };
  },
  methods: {
    deleteClick({ currentId, title }) {
      this.basesToUnlink = [];
      this.deleteRadio = "";
      this.currentId = currentId;
      this.sectionName = title;
      this.$store.dispatch("getBasesSection", currentId).then(() => {
        this.deleteDialog = true;
      });
    },
    unlinkAllBases() {
      this.basesToUnlink = [];
      this.getBasesInSection.forEach((base) => {
        // //console.log(base.idBase);
        this.basesToUnlink.push(base.idBase);
        // //console.log(this.basesToUnlink);
      });
      //console.log(this.basesToUnlink);
      this.selectKey++;
    },
    okClickDelete() {
      if (
        this.basesToUnlink &&
        this.basesToUnlink.length > 0 &&
        this.deleteRadio === "unlink"
      ) {
        this.$store.commit("setLoading", true);
        this.$store
          .dispatch("unlinkSectionInReference", {
            idBase: this.basesToUnlink,
            idSection: this.currentId,
          })
          .then(() => {
            return this.$store.dispatch("getSectionTable");
          })
          .then(() => {
            this.deleteDialog = false;
            this.deleteRadio = "";
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.deleteDialog = false;
            this.deleteRadio = "";
            this.$store.commit("setLoading", false);
          });
      } else if (this.deleteRadio === "hard") {
        this.$store
          .dispatch("getBasesSection", this.currentId)
          .then(() => {
            return this.$store.dispatch("getSectionPackets", this.currentId);
            // console.log(this.getBasesInSection);
          })
          .then(() => {
            this.deleteConfirmationDialog = true;
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (
        this.basesToUnlink &&
        this.basesToUnlink.length === 0 &&
        this.deleteRadio === "unlink"
      ) {
        this.$store.commit(
          "setError",
          this.$t("configTree.selectBaseForUnlink")
        );
      } else if (this.deleteRadio === "") {
        this.$store.commit("setError", this.$t("sections.selectOption"));
      }
    },
    deleteSectionHard() {
      this.$store
        .dispatch("delSectionHard", this.currentId)
        .then(() => {
          return this.$store.dispatch("getSectionTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
          this.deleteRadio = "";
          this.deleteDialog = false;
          this.deleteConfirmationDialog = false;
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit("setLoading", false);
        });
    },
    baseLabel(base) {
      let label = base.bname;
      if (base.balias && base.comment) {
        label += " (" + base.balias + ") -- " + base.comment;
      } else if (base.balias) label += " (" + base.balias + ")";
      else if (base.comment) label += " -- " + base.comment;
      return label;
    },
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      { headerName: i18n.t("tableHeaders.app.name"), field: "sectionName" },
      { headerName: i18n.t("tableHeaders.app.alias"), field: "sectionAlias" },
      {
        headerName: i18n.t("tableHeaders.app.apiType"),
        field: "sectionTypeApiName",
        cellClass: "center-column",
      },
      // { headerName: "Тип базы", field: "sectionTypeDbName" },
      { headerName: i18n.t("tableHeaders.app.path"), field: "sectionPath" },
      {
        headerName: i18n.t("tableHeaders.app.server"),
        field: "sectionServerName",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.app.isWebApp"),
        field: "webApp",
        valueGetter: (params) =>
          params.data.webApp === "0"
            ? i18n.t("tableHeaders.app.no")
            : i18n.t("tableHeaders.app.yes"),
        cellClass: "center-column",
      },
    ];
    this.$store.dispatch("getSectionTable").catch(() => {
      this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters([
      "getSectionsTableArray",
      "getBasesInSection",
      "sectionPackets",
    ]),
  },
  components: {
    myHeader: Header,
    ReferenceGrid,
  },
};
</script>

<style scoped>
.delete-dialog-element-name {
  font-weight: 600;
  text-align: center;
}
</style>